import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import Block from "../../Block/Block";

function ERZ() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>ERZ Dataset</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>In the course of my bachelor's thesis, I developed a dataset comprising 100 3D reconstructions representing a diverse array of minerals. This dataset was designed to evaluate a web application dedicated to mineral recognition. Each entry in the dataset consists of textured triangle meshes, crafted using the photogrammetry tool, Metashape. Additionally, the dataset includes the original set of images that formed the basis for these reconstructions.</BlockText>
        </BlockContent>
      </Block>

      <Block>
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
          <ul>
              <li>Dataset encompasses 100 3D reconstructions of minerals in the form of textured meshes.</li>
              <li>Reconstructions generated using the Metashape tool; source images for the reconstruction process are accessible within the dataset.</li>
              <li>Comprehensive metadata for each mineral is provided, detailing aspects such as name, weight, dimensions, and discovery site.</li>
              <li>Every mineral model is represented from 228 unique viewpoints, each in a 256x256 pixel resolution. This compilation includes RGB, depth, and chromaticity image variations.</li>
              <li>Associated with each image, there's a calculated color descriptor along with a HOG descriptor.</li>
          </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/minerals.webp'}/>
        </BlockContent>
      </Block>


      <Block colorTheme="light">
        <BlockContent width="100%"  textAlign="center">
          <BlockTitle>Comming Soon</BlockTitle>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default ERZ;